import { T } from '@tribeplatform/react-components/i18n'

import { PermissionsSettings } from '../PermissionsSettings.js'

export function CommunityPermissionsSettingsRouter() {
  return <PermissionsSettings />
}

export function CommunityPermissionsSettingsBreadCrumb() {
  return <T id="Settings.Permissions" defaultMessage="Permissions" />
}
